document.addEventListener('alpine:init', () => {
  Alpine.data('brandCarousel', () => ({
    interval: null,
    scrollAmount: 200,
    currentSlide: 1,
    totalSlides: 0,
    _hintAnnounced: false,
    _motionQuery: null,
    _motionHandler: null,
    _sectionUnloadHandler: null,

    init() {
      var self = this;
      var track = this.$refs.track;
      if (track) {
        this.totalSlides = track.children.length;
      }

      // Listen for reduced-motion preference changes
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._motionHandler = function (e) {
        if (e.matches) {
          self.pause();
        } else {
          self.resume();
        }
      };
      this._motionQuery.addEventListener('change', this._motionHandler);

      // Clean up on Shopify section unload (theme editor)
      this._sectionUnloadHandler = function (e) {
        if (self.$el && self.$el.closest('.shopify-section') === e.target) {
          self.destroy();
        }
      };
      document.addEventListener('shopify:section:unload', this._sectionUnloadHandler);

      if (!this._motionQuery.matches) {
        this.startAutoplay();
      }
    },

    startAutoplay() {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.scrollNext();
      }, 4000);
    },

    pause() {
      clearInterval(this.interval);
      this.interval = null;
    },

    resume() {
      if (this._motionQuery && this._motionQuery.matches) return;
      this.startAutoplay();
    },

    scrollNext() {
      const track = this.$refs.track;
      if (!track) return;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 10) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
        this.currentSlide = 1;
      } else {
        track.scrollBy({ left: this.scrollAmount, behavior: 'smooth' });
        this.currentSlide = Math.min(this.currentSlide + 1, this.totalSlides);
      }
      this._announceSlide();
    },

    scrollPrev() {
      const track = this.$refs.track;
      if (!track) return;
      if (track.scrollLeft <= 10) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
        this.currentSlide = this.totalSlides;
      } else {
        track.scrollBy({ left: -this.scrollAmount, behavior: 'smooth' });
        this.currentSlide = Math.max(this.currentSlide - 1, 1);
      }
      this._announceSlide();
    },

    announceHint() {
      if (this._hintAnnounced) return;
      this._hintAnnounced = true;
      var liveEl = this.$refs.liveRegion;
      if (!liveEl) return;
      liveEl.textContent = '';
      requestAnimationFrame(function () {
        liveEl.textContent = 'Use left and right arrow keys to navigate';
      });
    },

    handleKeydown(e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        this.scrollNext();
        this.pause();
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        this.scrollPrev();
        this.pause();
      }
    },

    _announceSlide() {
      var liveEl = this.$refs.liveRegion;
      if (!liveEl) return;
      liveEl.textContent = '';
      requestAnimationFrame(() => {
        liveEl.textContent = 'Showing brand ' + this.currentSlide + ' of ' + this.totalSlides;
      });
    },

    destroy() {
      clearInterval(this.interval);
      this.interval = null;
      if (this._motionQuery && this._motionHandler) {
        this._motionQuery.removeEventListener('change', this._motionHandler);
        this._motionQuery = null;
        this._motionHandler = null;
      }
      if (this._sectionUnloadHandler) {
        document.removeEventListener('shopify:section:unload', this._sectionUnloadHandler);
        this._sectionUnloadHandler = null;
      }
    }
  }));
});
